import React from 'react';
import { motion } from 'framer-motion';
export const Problem = () => {
  return <section className="py-20 bg-cream" data-id="element-191">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-192">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-193">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-forest" data-id="element-194">
            No es grasa. Es inflamación.
          </h2>
          <div className="space-y-6 text-lg text-charcoal-light leading-relaxed" data-id="element-195">
            <p data-id="element-196">
              La mayoría de los hombres y mujeres después de los 40 confunden la
              inflamación con grasa. Se matan en el gimnasio o pasan hambre,
              pero su abdomen sigue rígido y su mente nublada.
            </p>
            <p data-id="element-197">
              Esto sucede porque tu cuerpo ha activado un "freno de mano"
              metabólico debido al cortisol alto. Si intentas forzar la pérdida
              de peso sin apagar la inflamación primero, solo lograrás sentirte
              más agotado y frustrado. No necesitas comer menos, necesitas
              desinflamar tu sistema.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};